// Phase 33.3 D-06: "Save as venue" opens the existing venue form, prefilled
// from the history row and the current form values; what Dominique has typed
// wins over history.
//
// The venue form reads its initial values from a venues Row, so this builds
// a synthesized one (id 0, like the organizer modal's). Pure: no React, no
// Supabase.
import type { Database } from 'types/supabase'
import { isLocationFormatValid } from 'utils/location'
import type { DeskVenueSuggestion, EventFormValues } from './types'

type VenueRow = Database['public']['Tables']['venues']['Row']

/**
 * The event form values the prefill reads. `venue_phone` / `venue_website` are
 * set on the form by EventFormVenue although they are not in EventFormValues.
 */
export type SaveAsVenueFormValues = EventFormValues & {
  venue_phone?: string
  venue_website?: string
}

/** A typed value wins only when it is not blank. */
const typed = (value?: string | null): string | undefined =>
  (value ?? '').trim() !== '' ? (value as string) : undefined

export const buildSaveAsVenueRow = (
  values: SaveAsVenueFormValues,
  suggestion: DeskVenueSuggestion
): VenueRow => {
  const location = isLocationFormatValid(values.venue_location ?? '')
    ? values.venue_location
    : isLocationFormatValid(suggestion.location ?? '')
      ? suggestion.location
      : ''
  const [lat, lng] = location ? location.split(',').map(Number) : [null, null]

  return {
    id: 0,
    uid: null,
    created_at: '',
    picture: null,
    slug_en: null,
    slug_pt: null,
    name: typed(values.venue_name) ?? suggestion.name,
    address: typed(values.venue_address) ?? suggestion.address,
    description: typed(values.venue_description) ?? suggestion.description,
    description_pt: suggestion.descriptionPt,
    phone: typed(values.venue_phone) ?? suggestion.phone,
    website: typed(values.venue_website) ?? suggestion.website,
    location_lat: lat,
    location_long: lng,
    city_id: values.city_id,
    city: values.venue_city
  }
}
